import React from "react";

const Footer = () => {
  return (
    <div className="text-center container pt-3">
      <div className="row mt-2">
        <div className="col-12 bg-light text-center py-3">
          <p className="h4 dark-gray">
            Copyrights Zingbus {new Date().getFullYear()}
          </p>
        </div>
      </div>
      <hr />
    </div>
  );
};

export default Footer;
